import LoginRegisterHeader from './LoginRegisterHeader'
export default LoginRegisterHeader
